module.exports = __webpack_public_path__ + "img/achison.c6ad6bf1.png";